import { t } from "i18next"
import { PAGES, PAGE_SUBSECTIONS } from "utils/gtm/gtmEventsData"

import { Group } from "components/common"
import { InfoBlock } from "components/custom"
import { Tabs } from "antd"
import { TasksTable } from "features/tasks/components"
import getPrivilege from "utils/privileges/privileges"
import { useSelector } from "react-redux"
import { useState } from "react"
import { CallsTable } from "features/clients/components"
import LeadReviewTable from "features/leads/components/LeadReviewTable/leadReviewTable"
import { isModule } from "utils"

const TsrTabs = ({ lead, client, clientinLead, onClickAddTaskButton, activeKey, setActiveKey }) => {
  const privileges = useSelector(state => state.app.privileges)
  const isSharedLeadsPage = isModule("shared-leads")

  const getTaskType = () => {
    return clientinLead && lead ? (
      <TasksTable
        client={{
          ...clientinLead,
          leadIdsWithTasks: [lead?.inquiryId?.toString() || lead?.taskAgainstId?.toString() || lead?.id?.toString()],
        }}
        lead={{ inquiryIds: lead?.inquiryId?.toString() || lead?.taskAgainstId?.toString() || lead?.id?.toString() }}
        leadPrivileges={lead?.privileges}
        tsrTable
        stickyOffset={-24}
        tableStyle={{ "--table-selected-bg": "#fff" }}
        from={{ page: PAGES.telesales_listing_page, interacted_from: PAGE_SUBSECTIONS.telesales_listing_page }}
        isEditable
        onEditClick={onClickAddTaskButton}
      />
    ) : null
  }

  const getClientProfile = () => {
    return (
      <Group template="initial" gap="32px">
        <InfoBlock
          key={client?.salesProfile?.title}
          data={client?.salesProfile?.data}
          title={client?.salesProfile?.title}
        />
        <InfoBlock
          key={client?.demographicProfile?.title}
          data={client?.demographicProfile?.data}
          title={client?.demographicProfile?.title}
        />
        <InfoBlock
          key={client?.moreInfo?.title}
          data={client?.moreInfo?.data?.filter(e => e?.label !== "CNIC")}
          title={client?.moreInfo?.title}
        />
      </Group>
    )
  }

  const items = [
    {
      key: "tasks",
      label: t("Tasks"),
      children: getTaskType(),
    },
    !!getPrivilege(["can_view_call_logs"], lead?.privileges)
      ? {
          key: "callLogs",
          label: t("Call logs"),
          children: <CallsTable params={{ clientId: client?.id, excludeDateRange: true }} />,
        }
      : [],
    isSharedLeadsPage
      ? {
          key: "leadReviews",
          label: t("Reviews"),
          children: <LeadReviewTable client={client} lead={lead} />,
        }
      : [],
    !!getPrivilege(["can_view_client_details"], privileges)
      ? {
          key: "clientProfile",
          label: t("Client Profile"),
          children: getClientProfile(),
        }
      : [],
  ]

  return (
    <Tabs
      activeKey={activeKey}
      items={items}
      onChange={key => {
        setActiveKey(key)
      }}
    />
  )
}
export default TsrTabs
